import { Navigate } from 'react-router-dom'

import { useQuery } from 'modules/core/hooks/useQuery'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { OnboardingTabsDocument } from 'generated/resources/graphql'

const DiscoverGuardPage = () => {
  const { navigation } = useNavigation()
  const { data, loading } = useQuery(OnboardingTabsDocument)

  if (loading) return null

  if (!data) {
    return <Navigate replace to={navigation.discover.productUpdates.fullPath()} />
  }

  const canSeeModules = data.modules?._policies?.sidebarSeeModulesSubLevelItem?.can ?? false

  const to = canSeeModules
    ? navigation.discover.marketplaceModules.fullPath()
    : navigation.discover.productUpdates.fullPath()

  return <Navigate replace to={to} />
}

export default DiscoverGuardPage
